import React, { Component } from 'react'
import { Tabs } from 'hljd'
import { HeaderView } from '@merchant-backend/common-components'
import Styles from './style.module.less'
import { observer } from 'mobx-react'
import store from './store'
import Balance from './Balance'
import Card from './Card'
import { BOND_PATH_A } from '@constant'

const TabPane = Tabs.TabPane

@observer
export default class extends Component {
  tabChange = activeKey => {
    store.shop.tab_key = activeKey
  }

  componentDidMount() {
    store.getBaseData()
    store.getBondData()

    const {
      shop: { withdraw, pay_money }
    } = store
    if (withdraw - pay_money < 0) {
      this.setState({
        tabKey: '2'
      })
    }
  }

  render() {
    const {
      shop: { name, pay_money, tab_key, property }
    } = store

    let header = (
      <p key={0}>
        <a style={{ color: '#333' }} href={BOND_PATH_A}>
          消费者保障计划
        </a>{' '}
        > 缴纳放心购·保证金
      </p>
    )
    return (
      <HeaderView title={header}>
        <div className={Styles.container}>
          <div
            className={Styles.tip}
            style={{ display: true ? 'block' : 'none' }}
          >
            <div>需缴纳金额：{pay_money}.00元</div>
            <div className={Styles.close} onClick={this.close} />
          </div>

          <div className={Styles.category}>
            <div className={Styles.item}>
              开通商家：<span>{name}</span>
            </div>
            <div className={Styles.item}>
              经营范围：<span>{property?.name}</span>
            </div>
          </div>

          <div className={Styles.pay}>
            <Tabs type="card" activeKey={tab_key} onChange={this.tabChange}>
              <TabPane tab="余额购买" key="1">
                <Balance />
              </TabPane>
              <TabPane tab="银行卡购买" key="2">
                <Card />
              </TabPane>
            </Tabs>
          </div>
        </div>
      </HeaderView>
    )
  }
}
